export function apiBase(): string {
    const env = (import.meta as any).env || {};
    const viaEnv = env.VITE_HIVECORE_API_URL?.toString().trim();
    if (viaEnv) return viaEnv.replace(/\/+$/, '');
    if (env.DEV) return 'http://localhost:8080';
    return '';
}

/**
 * Build a full API URL, using apiBase() when available or falling back to relative URLs.
 * In non-dev environments without VITE_HIVECORE_API_URL, this returns relative URLs that work via proxy.
 *
 * @param path - API path (e.g., '/api/supervisor/mission' or 'api/supervisor/mission')
 * @returns Full URL or relative path
 */
export function apiUrl(path: string): string {
    const base = apiBase();
    const normalizedPath = path.startsWith('/') ? path : `/${path}`;
    return base ? `${base}${normalizedPath}` : normalizedPath;
}
